module.exports = __webpack_public_path__ + "static/media/viewIconButton.ea3af23c.svg";